import { fetchEntities } from 'actions/entities'
import SchemaForm from 'components/forms/SchemaForm'
import dotProp from "dot-prop";
import React from 'react'
import { connect } from 'react-redux'
import { Message } from "semantic-ui-react";
import invoiceConfigurationSchema from "../../forms/invoiceConfigurationSchema";

class InvoiceConfigurationForm extends React.Component {

  render () {
    return (
      <React.Fragment>
        {this.props.readonly ? <Message>{I18n.t('api.forms.not_in_scope')}</Message> : null}
        <SchemaForm entityName="invoiceConfiguration" {...this.props}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let readonly = dotProp.get(state, `entities.invoiceConfiguration.byId.${ownProps.entityId}.readOnly`)

  return {
    uiSchema: invoiceConfigurationSchema(state, {...ownProps, readonly: readonly}),
    readonly: readonly
  }
}

InvoiceConfigurationForm.defaultProps = {
  submitButton: true
}

export default connect(mapStateToProps)(InvoiceConfigurationForm);
